import { assessmentTasksTabContent } from '../constants/assessment-tasks.constant';
import { AssessmentTaskMessage } from './assessment-task-message';

export const AssessmentTaskNotFound = (): JSX.Element => (
  <AssessmentTaskMessage
    title={assessmentTasksTabContent.taskNotFound.title}
    body={assessmentTasksTabContent.taskNotFound.body}
  />
);
